import { get } from 'aws-amplify/api';

export type FeatureFlagValue = string | boolean | Record<string, unknown> | null;

export type FeatureFlagRecord = {
  pk: string;
  sk: string;
  value: FeatureFlagValue;
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
};

async function requestFeatureFlagsGet<T>(path: string): Promise<T> {
  const apiResponse = get({
    apiName: 'FeatureFlagsAPI',
    path,
  });
  const response = await apiResponse.response;
  const bodyText = await response.body.text();

  if (!bodyText) {
    throw new Error(`Empty feature flags response body for path: ${path}`);
  }

  return JSON.parse(bodyText) as T;
}

export async function listGlobalFlags(): Promise<FeatureFlagRecord[]> {
  return requestFeatureFlagsGet<FeatureFlagRecord[]>('/api/feature-flags/all/');
}

export async function listTenantFlags(tenantId: string): Promise<FeatureFlagRecord[]> {
  return requestFeatureFlagsGet<FeatureFlagRecord[]>(`/api/feature-flags/all/${tenantId}`);
}

export async function listUserFlags(
  tenantId: string,
  userId: string,
): Promise<FeatureFlagRecord[]> {
  return requestFeatureFlagsGet<FeatureFlagRecord[]>(
    `/api/feature-flags/all/${tenantId}/${userId}`,
  );
}

export async function getGlobalFlag(slug: string): Promise<FeatureFlagRecord> {
  return requestFeatureFlagsGet<FeatureFlagRecord>(`/api/feature-flags/${slug}`);
}

export async function getTenantFlag(slug: string, tenantId: string): Promise<FeatureFlagRecord> {
  return requestFeatureFlagsGet<FeatureFlagRecord>(`/api/feature-flags/${slug}/${tenantId}`);
}

export async function getUserFlag(
  slug: string,
  tenantId: string,
  userId: string,
): Promise<FeatureFlagRecord> {
  return requestFeatureFlagsGet<FeatureFlagRecord>(
    `/api/feature-flags/${slug}/${tenantId}/${userId}`,
  );
}
